<template>
  <div class="flex">
    <div class="branca">
      <v-container>
        <v-row class="mb-6" no-gutters>
          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="230" src="@/assets/img/dcomp.png" alt=""
            /></router-link>
          </v-col>

          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="250" src="@/assets/img/logo_UFS.png" alt=""
            /></router-link>
          </v-col>
        </v-row>
      </v-container>
      <div class="div-esq">
        <v-sheet width="400" class="mx-auto">
          <h1 class="poppins400">Nova senha</h1>
          <br />
          <div class="justify-content">
            <h4 class="poppins400">Insira o token e a nova senha abaixo.</h4>
            <br />
          </div>

          <v-form @submit.prevent="novaSenha()">
            <v-text-field
              v-model="token"
              required
              :rules="rules"
              variant="underlined"
              label="Token"
              prepend-inner-icon="mdi-lock-check-outline"
            >
            </v-text-field>
            <v-text-field
              @input="validatePassword"
              v-model="password"
              label="Insira sua senha"
              variant="underlined"
              prepend-inner-icon="mdi-lock-outline"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append-inner="showPassword = !showPassword"
              required
            ></v-text-field>
            <ul class="flex-column" style="list-style: none">
              <li>
                <div v-if="!validadores.tamanho">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos 8 caracteres.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos 8 caracteres.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.uppercase">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos uma letra maiúscula.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos uma letra maiúscula.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.numero">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos um número.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos um número.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.caractereEspecial">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">
                    Pelo menos um dos caracteres: $, *, &, @, #.
                  </p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">
                    Pelo menos um dos caracteres: $, *, &, @, #.
                  </p>
                </div>
              </li>
            </ul>
            <br />

            <v-btn
              type="submit"
              block
              class="mt-2 button-config"
              rounded="pill"
            >
              Confirmar
            </v-btn>

            <v-alert
              v-if="showAlert"
              :type="alertType"
              @input="showAlert = false"
              closable
              class="mt-2 text-left"
            >
              {{ alertMessage }}
            </v-alert>
          </v-form>
        </v-sheet>
      </div>
    </div>
    <div class="azul">
      <div class="div-dir">
        <img
          class="img-sispi"
          src="../assets/img/logo_dark_nobg.png"
          alt="SISGIP - Sistema de Gestão Integrada de Projetos"
        />
        <h1 class="texto-inicio">Bem-vindos ao SISGIP!</h1>
        <h1 class="texto-inicio">Sistema de Gestão Integrada de Projetos</h1>
        <br /><br />
        <h3 class="subtexto-inicio">
          Elevando a Gestão de Projetos a Novos Patamares.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/fonts.css';
import '@/assets/css/login-validacao-cadastro.css';
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  data() {
    return {
      token: '',
      password: '',
      showPassword: false,
      showAlert: false,
      validacao: {},
      validadores: {
        tamanho: false,
        uppercase: false,
        numero: false,
        caractereEspecial: false,
      },
    };
  },
  created() {
    this.fetchToken();
  },
  methods: {
    async novaSenha() {
      this.showAlert = false;
      try {
        await axios.put(`${API_URL}/usuarios/senha/update`, {
          token: this.token,
          senha: this.password,
        });
        this.showAlert = true;
        this.alertType = 'success';
        this.alertMessage = `Sua senha foi alterada com sucesso. Estamos te redirecionando...`;
        setTimeout(() => {
          this.$router.push('/login');
        }, 2000);
      } catch (error) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertMessage = `${error.response.data.error}`;
      }
    },

    fetchToken() {
      this.token = this.$route.query.token;
    },

    validatePassword() {
      const password = this.password;
      this.validadores = {
        tamanho: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        numero: /[0-9]/.test(password),
        caractereEspecial: /[$*&@#]/.test(password),
      };

      // Caso queira deixar o botão disable, o validacao serve para verificar todos os validadores
      this.validacao = Object.values(this.validadores).every(
        (validadores) => validadores,
      );
    },
  },
};
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
li div {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  float: left;
}
</style>
